import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

type Item = {
  text: string | number | object,
  value: string | number | object,
  disabled: boolean,
  divider: boolean,
  header: string
}

type Props = {
  disabled?: boolean,
  value?: any,
  items: (Item | string)[],
  lastNegative?: boolean,
  itemSlot?: boolean,
  height?: string | number,
  selectionSlot?: boolean,
  solo?: boolean,
  flat?: boolean,
  outlined?: boolean,
  placeholder?: string,
  rules?: Array<string | boolean | ((value: object) => boolean | string)>,
  hideDetails?: boolean,
  closeOnClick?: boolean,
  itemText?: string,
  itemValue?: string,
  error?: boolean,
  errorMessages?: string | string[],
  appendIcon?: string,
  returnObject?: boolean,
  contentClass?: string,
  loading?: boolean | string,
  isAttached?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectBox',
  props: {
    disabled: { type: Boolean },
    value: null,
    items: null,
    lastNegative: { type: Boolean },
    itemSlot: { type: Boolean },
    height: { default: 36 },
    selectionSlot: { type: Boolean },
    solo: { type: Boolean },
    flat: { type: Boolean },
    outlined: { type: Boolean, default: true },
    placeholder: null,
    rules: { default: () => [] },
    hideDetails: { type: Boolean, default: true },
    closeOnClick: { type: Boolean, default: false },
    itemText: { default: 'text' },
    itemValue: { default: 'value' },
    error: { type: Boolean, default: false },
    errorMessages: { default: '' },
    appendIcon: { default: '$icon_arrow_down' },
    returnObject: { type: Boolean, default: true },
    contentClass: null,
    loading: { type: [Boolean, String], default: false },
    isAttached: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled?: boolean, value?: any, items: (Item | string)[], lastNegative?: boolean, itemSlot?: boolean, height: string | number, selectionSlot?: boolean, solo?: boolean, flat?: boolean, outlined: boolean, placeholder?: string, rules: Array<string | boolean | ((value: object) => boolean | string)>, hideDetails: boolean, closeOnClick: boolean, itemText: string, itemValue: string, error: boolean, errorMessages: string | string[], appendIcon: string, returnObject: boolean, contentClass?: string, loading: boolean | string, isAttached: boolean };





const selectedItem = computed({
  get: () => props.value,
  set: (newValue) => {
    if (newValue !== props.value) {
      emit("input", newValue);
    }
  }
});

const loaderColor = computed(() => props.error ? 'negative' : 'secondaryMedium');



return { __sfc: true,props, emit, selectedItem, loaderColor }
}

})